"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qs = void 0;
function qs(obj) {
    const params = new URLSearchParams();
    if (typeof obj === 'string') {
        obj = JSON.parse(obj);
    }
    Object.keys(obj).forEach((key) => {
        params.append(key, String(obj[key]));
    });
    return params.toString();
}
exports.qs = qs;
//# sourceMappingURL=utils.js.map